import {
  Box,
  Carousel,
  DsmColor,
  Grid,
  GridColumn,
  CarouselSlide
} from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React from 'react';
import VisualFilterCard from './subcomponents/VisualFilterCard.jsx';
import classes from './index.module.scss';

const WalkinCarousel = ({walkinCarouselData}) => {
  if (!walkinCarouselData) return null;
  const { title, images:cards = [] } = walkinCarouselData;

  return (
    <section
      className={clsx(classes.carouselWrapper, "koh-three-image-product-carousel")}
    >

      <div className="koh-product-carousel">
        <div class="koh-text-description">{title}</div>
        <Box
          component="div"
          mod="white"
          paddingBlock={20}
          backgroundColor={DsmColor.BackgroundPrimary}
          maxWidth="100%"
          style={{ overflow: 'hidden' }}
          className={clsx('kohler-visual-filter-root')}
        >
          <Grid >
            <GridColumn className={classes.visualFilterContent}>
              <Carousel
                includeGapInSize={false}
                slideGap="0px"
                slideSize="33.3333%"
                align="start"
                loop={true}
                containScroll="trimSnaps"
                carouselControlProps={{
                  variant: 'slider',
                  isOnPhoto: true,
                }}
                className={classes.visualFilter}
              >
                {cards.map((imageCard) => (
                  <CarouselSlide className={classes.productCardCarouselCard} key={imageCard?.sys?.id}>
                    <VisualFilterCard {...imageCard?.fields} />
                  </CarouselSlide>
                ))}
              </Carousel>
            </GridColumn>
          </Grid>
        </Box>
      </div>
    </section>
  );
};

export default WalkinCarousel;
